import React from "react";
import Routes from "./Routes";

import { BuyerAuthProvider } from "./contexts/BuyerAuthContext";
import { LanguageProvider } from "./contexts/LanguageContext";

function App() {
  return (
    <BuyerAuthProvider>
      <LanguageProvider>
        <Routes />
      </LanguageProvider>
    </BuyerAuthProvider>
  );
}

export default App;
